<template>
  <div>
    <common-dialog
      ref="dialog"
      width="950px"
      unit="角色"
      edit-title
      title="查看角色"
      id-key="RoleId"
      form-label-width="110px"
      :data="data"
      :form-rules="rules"
      :get-data-func="api.getRoleWithMenu"
      :before-save="onBeforeSave"
      @create-opened="onCreateOpened"
      :save-func="api.save"
      @edit-opened="onEditOpened"
      @details-opened="onDetailsOpened"
      @closed="onClosed"
      @close-saved="$emit('close-saved')"
    >
      <template slot="form">
        基本信息
        <el-row class="row-border">
          <el-row>
            <el-col :span="12">
              <el-form-item label="角色名称" prop="RoleName">
                {{data.RoleName}}
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="角色类型" prop="RoleType">
                {{data.RoleType==0?'运营商':(data.RoleType==1?'驾校':'品牌')}}
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12">
              <el-form-item label="状态" prop="Status">
                {{data.Status==0?'屏蔽':'正常'}}
              </el-form-item>
            </el-col>
          </el-row>
          <el-form-item label="功能操作权限" v-if="!isMB">
            <menu-list ref="menuList" />
          </el-form-item>
          <menu-list ref="menuList" v-if="isMB" />
        </el-row>
        其他信息
        <el-row class="row-border">
          <el-row>
            <el-col :span="12">
              <el-form-item label="创建人">
                {{data.AddUserName}}
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="创建时间">
                {{data.AddTime}}
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12">
              <el-form-item label="修改人">
                {{data.UpdateUserName}}
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="修改时间">
                {{data.UpdateTime}}
              </el-form-item>
            </el-col>
          </el-row>
        </el-row>
      </template>
      <template #footer>
        <el-button @click="close">关闭</el-button>
      </template>
    </common-dialog>
  </div>
</template>
<script>
import commonDialog from "@/components/common/dialog";
import menuList from "./menuList2";
import editDialogMixin from "@/mixins/editDialog";

export default {
  mixins: [editDialogMixin],
  components: {
    commonDialog,
    menuList,
  },
  data() {
    return {
      data: {
        RoleId: 0,
        RoleName: "",
        Remark: "",
        Status: 1,
        RoleType: null,
        // DataRange: 0,
        AddUserName: "",
        AddTime: "",
        UpdateUserName: "",
        UpdateTime: "",
        Menus: [],
      },
      api: require("@/api/sy/role").default,
      isMB: this.$store.state.isMB,
      rules: {
        RoleName: [{ required: true, message: "角色名称不能为空", trigger: "change" }],
        RoleType: [{ required: true, message: "请选择角色类型" }],
      },
    };
  },
  computed: {},
  methods: {
    onCreateOpened() {
      this.api.getRoleWithMenu(0).then((res) => {
        return this.$refs.menuList.setData(res.Data.Menus);
      });
    },
    onEditOpened(data) {
      return this.$refs.menuList.setData(data.Menus);
    },
    onDetailsOpened(data) {
      var obj = { fake: true }
      data.Menus.forEach(e => {
        if(e.MenuFuncs.length == 1 && e.MenuFuncs[0].FuncName != "浏览") {
          e.MenuFuncs.splice(0,0,obj);
        } else if(e.MenuFuncs.length == 2) {
          if(e.MenuFuncs[1].FuncName != "添加") {
            e.MenuFuncs.splice(1,0,obj);
          }
        } else if(e.MenuFuncs.length == 3) {
          if(e.MenuFuncs[1].FuncName != "添加") {
            e.MenuFuncs.splice(1,0,obj);
          }
          if(e.MenuFuncs[2].FuncName != "修改") {
            e.MenuFuncs.splice(2,0,obj);
          }
          if(e.MenuFuncs[e.MenuFuncs.length-1].FuncName == "审批") {
            e.MenuFuncs.splice(3,0,obj);
          }
        } else if(e.MenuFuncs.length == 4) {
          if(e.MenuFuncs[1].FuncName != "添加") {
            e.MenuFuncs.splice(1,0,obj);
          }
          if(e.MenuFuncs[2].FuncName != "修改") {
            e.MenuFuncs.splice(2,0,obj);
          }
          if(e.MenuFuncs[3].FuncName != "删除") {
            e.MenuFuncs.splice(3,0,obj);
          }
        }
        if(e.MenuFuncs[e.MenuFuncs.length-1].FuncName == "备案" && e.MenuFuncs.length < 6) {
          var time = 6 - e.MenuFuncs.length; 
          for (let i = 0; i < time; i++) {
            e.MenuFuncs.splice(e.MenuFuncs.length-1,0,obj);
          }
        }
      })
      return this.$refs.menuList.setData(data.Menus);
    },
    onBeforeSave() {
      let roleMenus = this.$refs.menuList.getCheckedRows();
      this.data.Menus = roleMenus;
      return true;
    },
    onClosed() {
      this.$refs.menuList.reset();
    },
  },
};
</script>